import { render, staticRenderFns } from "./SelectShipping.vue?vue&type=template&id=c980578a&"
import script from "./SelectShipping.vue?vue&type=script&lang=js&"
export * from "./SelectShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports